import { route } from 'constant'

export const breadcrumbsData = [{ url: route.userManagement, title: 'User management' }, { title: 'Create User' }]
